module.exports = __webpack_public_path__ + "img/checkmark.87ec6b4f.svg";